<template>
  <div
    v-if="notice"
    class="flex flex-col items-center"
  >
    <PlayerIdleStatusLine
      v-if="notice.mode === 'restoring'"
      :uppercase="false"
    >
      {{ notice.text }}
    </PlayerIdleStatusLine>
    <div
      v-else
      class="mt-[1.5vh] flex max-w-[min(80vw,36rem)] items-start gap-[1vw] rounded-lg border border-amber-400/35 bg-amber-500/15 px-[2vw] py-[1.25vh] text-left text-amber-100"
      style="font-size: clamp(0.65rem, 1.05vw, 0.95rem);"
      role="status"
    >
      <span>{{ notice.text }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import PlayerIdleStatusLine from '@/components/PlayerIdleStatusLine.vue'
import { fetchWifiStatus } from '@/helpers/androidWifiProvisioning'
import { wifiText } from '@/helpers/wifiCopy'
import { getPlatform } from '@/platform'

const notice = ref<{ mode: 'restoring' | 'retrying', text: string } | null>(null)
let timer: ReturnType<typeof setInterval> | null = null

async function refresh(): Promise<void> {
  if (getPlatform() !== 'android') {
    notice.value = null
    return
  }
  const status = await fetchWifiStatus()
  if (status == null || status.restore === 'idle') {
    notice.value = null
    return
  }
  if (status.restore === 'restoring') {
    notice.value = { mode: 'restoring', text: wifiText('boot.restoring') }
    return
  }
  const seconds = Math.max(0, Math.ceil((status.nextAttemptMs - Date.now()) / 1000))
  notice.value = {
    mode: 'retrying',
    text: wifiText('boot.retrying', { s: seconds })
  }
}

onMounted(() => {
  if (getPlatform() !== 'android') {
    return
  }
  void refresh()
  timer = setInterval(() => {
    void refresh()
  }, 2000)
})

onBeforeUnmount(() => {
  if (timer != null) {
    clearInterval(timer)
  }
})
</script>
